var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3144 18.354C23.5405 13.4353 23.7782 5.22266 18.875 0.0129395L9.42401 8.90795L18.3144 18.354Z",
    fill: "#E79E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45117 8.88208C4.22501 13.8008 3.9873 22.0134 8.89055 27.2231L18.3415 18.3281L9.45117 8.88208Z",
    fill: "#FECE26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8164 9.48633C32.7326 14.7098 32.4682 22.9216 27.2558 27.8274L18.3654 18.3813L27.8164 9.48633Z",
    fill: "#FECE26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2693 27.8145C22.0431 32.7332 13.8312 32.4731 8.92792 27.2634L18.3789 18.3684L27.2693 27.8145Z",
    fill: "#E79E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany05);
export default __webpack_public_path__ + "static/media/company-05.a9481b09de3bd7169b69afa0434364f8.svg";
export { ForwardRef as ReactComponent };